import React, { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';

import { Header } from '@expo/html-elements';

import { useA11ySelector } from '@sg/a11y-helpers';
import { theme } from '@sg/garnish';

/**
 * Channel, location and time wrapper.
 */
export const BagHeaderContainer = (props: PropsWithChildren) => {
  const { children } = props;

  const a11ySelector = useA11ySelector('bag.header');

  return (
    <Header style={styles.container} {...a11ySelector.props}>
      {children}
    </Header>
  );
};

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    width: '100%',
    alignItems: 'flex-start',
    gap: theme.spacing['2'],
  },
});
